import gql from 'graphql-tag';

export const GET_REGIONS = gql`
  query RegionsDictionary($input: RegionsDictionaryInput!) {
    dealSheets {
      result: regionsDictionary(input: $input) {
        error
        success
        list {
          label
          value
        }
      }
    }
  }
`;
